import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: 12, xl: 6, md: 4, sd: 4 } },
            [
              _c(
                VMenu,
                {
                  attrs: {
                    "close-on-content-click": false,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "290px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VTextField,
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    "append-icon": "event",
                                    readonly: "",
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "auto",
                                    label: _vm.$t(
                                      "chatbots.dashboard.range_date"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formattedDate,
                                    callback: function ($$v) {
                                      _vm.formattedDate = $$v
                                    },
                                    expression: "formattedDate",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.menu,
                    callback: function ($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu",
                  },
                },
                [
                  _c(VDatePicker, {
                    attrs: { range: "", scrollable: "" },
                    on: { input: _vm.updateFormattedDate },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: 12, xl: 6, md: 4, sd: 4 } },
            [
              _c(VAutocomplete, {
                attrs: {
                  label: _vm.$t("chatbots.dashboard.project"),
                  items: _vm.proyectos,
                  multiple: "",
                  outlined: "",
                  dense: "",
                  filled: _vm.view,
                  readonly: _vm.view,
                  "item-text": "name",
                  "item-value": "id",
                  chips: "",
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                  ],
                },
                model: {
                  value: _vm.selectedProyectos,
                  callback: function ($$v) {
                    _vm.selectedProyectos = $$v
                  },
                  expression: "selectedProyectos",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: 12, xl: 6, md: 4, sd: 4 } },
            [
              _c(VAutocomplete, {
                attrs: {
                  label: _vm.$t("chatbots.dashboard.user"),
                  items: _vm.usuarios,
                  multiple: "",
                  outlined: "",
                  dense: "",
                  filled: _vm.view,
                  readonly: _vm.view,
                  "item-text": "name",
                  "item-value": "id",
                  chips: "",
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                  ],
                },
                model: {
                  value: _vm.selectedUsuarios,
                  callback: function ($$v) {
                    _vm.selectedUsuarios = $$v
                  },
                  expression: "selectedUsuarios",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(VCol, { attrs: { cols: 12 } }, [
            _c("div", { ref: "lineChart", attrs: { id: "line-chart" } }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }